// 官网页面的 <head>：标题、描述、canonical、中英互指（hreflang）、分享卡片（Open Graph）。
// 构建脚本用 headHtml 写进静态页；浏览器里切页面时用 applyHead 更新同一组标签。
import { SITE_ORIGIN } from './siteRoutes.js';

const OG_IMAGE = `${SITE_ORIGIN}/bizsprite-logo.png`;

// [tag, attributes] in a fixed order; every tag carries data-site-head so applyHead can replace them.
export function headTags(meta) {
  const linked = meta.canonical ? [ // the 404 page has no address of its own
    ['link', { rel: 'canonical', href: meta.canonical }],
    ...Object.entries(meta.alternates).map(([lang, href]) => ['link', { rel: 'alternate', hreflang: lang === 'zh' ? 'zh-Hans' : 'en', href }]),
    ['link', { rel: 'alternate', hreflang: 'x-default', href: meta.alternates.en }],
    ['meta', { property: 'og:url', content: meta.canonical }],
  ] : [];
  const tags = [
    ['meta', { name: 'description', content: meta.description }],
    ...linked,
    ['meta', { property: 'og:type', content: 'website' }],
    ['meta', { property: 'og:site_name', content: 'Bizsprite' }],
    ['meta', { property: 'og:title', content: meta.title }],
    ['meta', { property: 'og:description', content: meta.description }],
    ['meta', { property: 'og:image', content: OG_IMAGE }],
    ['meta', { property: 'og:locale', content: meta.lang === 'zh' ? 'zh_CN' : 'en_US' }],
    ['meta', { name: 'twitter:card', content: 'summary' }],
  ];
  if (meta.noindex) tags.push(['meta', { name: 'robots', content: 'noindex' }]);
  return tags;
}

const escape = (value) => String(value ?? '')
  .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export const escapeHtml = escape;

export function headHtml(meta) {
  return [`<title>${escape(meta.title)}</title>`,
    ...headTags(meta).map(([tag, attrs]) => `<${tag} ${Object.entries(attrs).map(([k, v]) => `${k}="${escape(v)}"`).join(' ')} data-site-head>`),
  ].join('');
}

export function applyHead(meta, doc = document) {
  doc.title = meta.title;
  doc.documentElement.lang = meta.lang === 'zh' ? 'zh-Hans' : 'en';
  // index.html ships its own generic description; the page's tags replace it.
  doc.head.querySelectorAll('[data-site-head], meta[name="description"]').forEach((el) => el.remove());
  headTags(meta).forEach(([tag, attrs]) => {
    const el = doc.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    el.setAttribute('data-site-head', '');
    doc.head.appendChild(el);
  });
}
